import { render, staticRenderFns } from "./dataTitle.vue?vue&type=template&id=48f7faa2&scoped=true&"
import script from "./dataTitle.vue?vue&type=script&lang=js&"
export * from "./dataTitle.vue?vue&type=script&lang=js&"
import style0 from "./dataTitle.vue?vue&type=style&index=0&id=48f7faa2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f7faa2",
  null
  
)

export default component.exports